var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccoladesFrame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1170,
    height: 366,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#accolades_frame_svg__clip0_5284_132534)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1170,
    height: 366,
    rx: 24,
    fill: "#110C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.078 299H-336c-7.732 0-14 6.268-14 14v49.662c0 7.732 6.268 14 14 14h318.923c7.731 0 14 6.268 14 14v216.017c0 7.732 6.267 14 14 14h82.413c7.732 0 14-6.268 14-14V313c0-7.732-6.268-14-14-14H-3.078z",
    fill: "#1A1353"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.5,
    y: 662.5,
    width: 480,
    height: 325,
    rx: 13.5,
    transform: "rotate(-180 136.5 662.5)",
    stroke: "#00AECF",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.41 48.571h332.93c7.73 0 14-6.268 14-14V-9.633c0-7.732-6.27-14-14-14h-318.93c-7.73 0-14-6.268-14-14v-198.865c0-7.732-6.26-14-14-14H968c-7.732 0-14 6.268-14 14V34.571c0 7.732 6.268 14 14 14h96.41z",
    fill: "#1A1353"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1536.5,
    y: 67.152,
    width: 480,
    height: 296.231,
    rx: 13.5,
    transform: "rotate(-180 1536.5 67.152)",
    stroke: "#4BB699",
    strokeWidth: 5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "accolades_frame_svg__clip0_5284_132534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1170,
    height: 366,
    rx: 24,
    fill: "#fff"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTE3MCIgaGVpZ2h0PSIzNjYiIHZpZXdCb3g9IjAgMCAxMTcwIDM2NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzUyODRfMTMyNTM0KSI+CjxyZWN0IHdpZHRoPSIxMTcwIiBoZWlnaHQ9IjM2NiIgcng9IjI0IiBmaWxsPSIjMTEwQzM5Ii8+CjxwYXRoIGQ9Ik0tMy4wNzc1NSAyOTlMLTMzNiAyOTlDLTM0My43MzIgMjk5IC0zNTAgMzA1LjI2OCAtMzUwIDMxM0wtMzUwIDM2Mi42NjJDLTM1MCAzNzAuMzk0IC0zNDMuNzMyIDM3Ni42NjIgLTMzNiAzNzYuNjYyTC0xNy4wNzc1IDM3Ni42NjJDLTkuMzQ1NTUgMzc2LjY2MiAtMy4wNzc1NSAzODIuOTMgLTMuMDc3NTUgMzkwLjY2MkwtMy4wNzc1NSA2MDYuNjc5Qy0zLjA3NzU1IDYxNC40MTEgMy4xOTA0NiA2MjAuNjc5IDEwLjkyMjQgNjIwLjY3OUw5My4zMzYyIDYyMC42NzlDMTAxLjA2OCA2MjAuNjc5IDEwNy4zMzYgNjE0LjQxMSAxMDcuMzM2IDYwNi42NzlMMTA3LjMzNiAzNzYuNjYyTDEwNy4zMzYgMzEzQzEwNy4zMzYgMzA1LjI2OCAxMDEuMDY4IDI5OSA5My4zMzYyIDI5OUwtMy4wNzc1NSAyOTlaIiBmaWxsPSIjMUExMzUzIi8+CjxyZWN0IHg9IjEzNi41IiB5PSI2NjIuNSIgd2lkdGg9IjQ4MCIgaGVpZ2h0PSIzMjUiIHJ4PSIxMy41IiB0cmFuc2Zvcm09InJvdGF0ZSgtMTgwIDEzNi41IDY2Mi41KSIgc3Ryb2tlPSIjMDBBRUNGIiBzdHJva2Utd2lkdGg9IjUiLz4KPHBhdGggZD0iTTEwNjQuNDEgNDguNTcxTDEzOTcuMzQgNDguNTcxMUMxNDA1LjA3IDQ4LjU3MTEgMTQxMS4zNCA0Mi4zMDMgMTQxMS4zNCAzNC41NzExTDE0MTEuMzQgLTkuNjMyNjNDMTQxMS4zNCAtMTcuMzY0NiAxNDA1LjA3IC0yMy42MzI2IDEzOTcuMzQgLTIzLjYzMjZMMTA3OC40MSAtMjMuNjMyNkMxMDcwLjY4IC0yMy42MzI2IDEwNjQuNDEgLTI5LjkwMDcgMTA2NC40MSAtMzcuNjMyNkwxMDY0LjQxIC0yMzYuNDk4QzEwNjQuNDEgLTI0NC4yMyAxMDU4LjE1IC0yNTAuNDk4IDEwNTAuNDEgLTI1MC40OThMOTY4IC0yNTAuNDk4Qzk2MC4yNjggLTI1MC40OTggOTU0IC0yNDQuMjMgOTU0IC0yMzYuNDk4TDk1NCAtMjMuNjMyNkw5NTQgMzQuNTcxQzk1NCA0Mi4zMDMgOTYwLjI2OCA0OC41NzEgOTY4IDQ4LjU3MUwxMDY0LjQxIDQ4LjU3MVoiIGZpbGw9IiMxQTEzNTMiLz4KPHJlY3QgeD0iMTUzNi41IiB5PSI2Ny4xNTIxIiB3aWR0aD0iNDgwIiBoZWlnaHQ9IjI5Ni4yMzEiIHJ4PSIxMy41IiB0cmFuc2Zvcm09InJvdGF0ZSgtMTgwIDE1MzYuNSA2Ny4xNTIxKSIgc3Ryb2tlPSIjNEJCNjk5IiBzdHJva2Utd2lkdGg9IjUiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF81Mjg0XzEzMjUzNCI+CjxyZWN0IHdpZHRoPSIxMTcwIiBoZWlnaHQ9IjM2NiIgcng9IjI0IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgAccoladesFrame as ReactComponent };